import { PrescriberContactDataComponent } from './prescriber-contact-data/prescriber-contact-data.component';
import { RequestFinanceComponent } from './request-finance/request-finance.component';
import { SharedModule } from '@app/@shared';
import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';

import { TranslateModule } from '@ngx-translate/core';

import { MaterialModule } from '@app/material.module';
import { PointOfSaleComponent } from './point-of-sale/point-of-sale.component';
import { RequestDataCardComponent } from './request-data-card/request-data-card.component';
import { RequestDataMgComponent } from './request-data-mg/request-data-mg.component';
import { HolderDataComponent } from './holder-data/holder-data.component';
import { ContactDataComponent } from './contact-data/contact-data.component';
import { SocioeconomicDataComponent } from './socioeconomic-data/socioeconomic-data.component';
import { RequestDataAutosComponent } from './request-data-autos/request-data-autos.component';
import { RequestDataUptakeComponent } from './request-data-uptake/request-data-uptake.component';
import { RequestFinanceMgComponent } from './request-finance-mg/request-finance-mg.component';
import { RequestBasicContactComponent } from './request-basic-contact/request-basic-contact.component';
import { DirectDebitComponent } from './direct-debit/direct-debit.component';
import { RequestObservationsComponent } from './request-observations/request-observations.component';
import { InsuranceComponent } from './insurance/insurance.component';
import { InputMaskModule } from '@ngneat/input-mask';
import { HistoricalComponent } from './historical/historical.component';
import { RequestDocumentationComponent } from './request-documentation/request-documentation.component';
import { RequestHeaderComponent } from './request-header/request-header.component';
import { RequestPanelComponent } from './request-panel/request-panel.component';
import { SearchPanelComponent } from './search-panel/search-panel.component';
import { CalculatorHeaderComponent } from './calculator-header/calculator-header.component';
import { TransformNumberPipe } from '@app/@shared/pipes/transform-number.pipe';
import { TracesComponent } from './traces/traces.component';
import { FinancingAmountComponent } from './financing-amount/financing-amount.component';

@NgModule({
  imports: [
    FlexLayoutModule,
    MaterialModule,
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
    SharedModule,
    InputMaskModule.forRoot({ inputSelector: 'input', isAsync: false }),
  ],
  declarations: [
    PointOfSaleComponent,
    RequestDataCardComponent,
    RequestDataMgComponent,
    HolderDataComponent,
    ContactDataComponent,
    SocioeconomicDataComponent,
    RequestDataAutosComponent,
    RequestDataUptakeComponent,
    RequestFinanceComponent,
    RequestFinanceMgComponent,
    RequestBasicContactComponent,
    DirectDebitComponent,
    RequestObservationsComponent,
    InsuranceComponent,
    HistoricalComponent,
    RequestDocumentationComponent,
    RequestHeaderComponent,
    RequestPanelComponent,
    SearchPanelComponent,
    CalculatorHeaderComponent,
    TracesComponent,
    FinancingAmountComponent,
    PrescriberContactDataComponent,
  ],
  exports: [
    PointOfSaleComponent,
    RequestDataCardComponent,
    RequestDataMgComponent,
    HolderDataComponent,
    ContactDataComponent,
    SocioeconomicDataComponent,
    RequestDataAutosComponent,
    RequestDataUptakeComponent,
    RequestFinanceMgComponent,
    RequestBasicContactComponent,
    DirectDebitComponent,
    RequestObservationsComponent,
    TranslateModule,
    RequestFinanceComponent,
    InsuranceComponent,
    HistoricalComponent,
    RequestDocumentationComponent,
    RequestHeaderComponent,
    RequestPanelComponent,
    SearchPanelComponent,
    CalculatorHeaderComponent,
    TracesComponent,
    FinancingAmountComponent,
    PrescriberContactDataComponent,
  ],
  providers: [DecimalPipe, TransformNumberPipe],
})
export class RequestsSharedModule {}
